<template>
    <activation-content-metrics-provider
        v-slot="{
            brief,
            task,
            content,
            isLoading,
            isSubmitting,
            errors,
            errorMessage,
            uploadScreenshotUrl,
            handleFileChange,
            handleResetUploads,
            uploadHeaders,
            uploadedFiles,
            isFileUploading,
            isFileDeleting,
            back,
            updateContentMetrics,
            handleScreenshotsSubmitted,
            handleFileDeleted,
            handleBeforeUploadValidation
        }"
        style="height: 100%"
    >
        <activation-content-metrics-view
            :brief="brief"
            :task="task"
            :content="content"
            :is-loading="isLoading"
            :is-submitting="isSubmitting"
            :errors="errors"
            :error-message="errorMessage"
            :upload-screenshot-url="uploadScreenshotUrl"
            :handle-file-change="handleFileChange"
            :upload-headers="uploadHeaders"
            :uploaded-files="uploadedFiles"
            :is-file-uploading="isFileUploading"
            :is-file-deleting="isFileDeleting"
            :handle-before-upload-validation="handleBeforeUploadValidation"
            @file-change="handleFileChange"
            @reset-uploads="handleResetUploads"
            @back="back"
            @update-content-metrics="updateContentMetrics"
            @screenshots-submitted="handleScreenshotsSubmitted"
            @file-deleted="handleFileDeleted"
        />
    </activation-content-metrics-provider>
</template>

<script>
    import ActivationContentMetricsProvider from '../providers/activation-brief-steps/ActivationContentMetricsProvider.vue';
    import ActivationContentMetricsView from '../data-views/activation-briefs/partials/tasks/ActivationContentMetricsView.vue';

    export default {
        name: 'ActivationContentMetricsRouterView',
        components: {
            ActivationContentMetricsProvider,
            ActivationContentMetricsView
        }
    };
</script>
